import React from 'react';
import './AboutP.css'

const AboutP = (props) => {
    return ( 
        <p className='AboutP'>
            {props.AboutPText}
        </p>
     );
}
 
export default AboutP;